import React, { FC } from 'react'
import { Spinner } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import { FormLayoutContent, FormLayout } from 'components/FormLayout';
import useFqdn from '../../hooks/useFqdn'
import useDomainForm from '../../hooks/useDomainForm'
import { FqdnFormHeader } from '../../components/FqdnFormHeader'
import { FqdnDomainFormGrid } from '../../components/FqdnDomainFormGrid'

export const FqdnCreate: FC = () => {
    const { t } = useTranslation()
    const { isLoading } = useFqdn()
    const {
      domainNames, domainGroup, setDomainGroup, handleClickSave, handleCellValueChanged, handleClickAddDomainItem, handleClickRemoveDomainItem
    } = useDomainForm()

    return (
      <div data-testid="FqdnCreate">
        <FormLayout>
          <FormLayoutContent>
            { isLoading && <Spinner aria-label="Loading..." /> }
            { !isLoading && (
            <React.Fragment>
              <FqdnFormHeader title={t('fqdn.grid.newItemTitle')} onClickSave={handleClickSave} />
              <FqdnDomainFormGrid
                domainGroup={domainGroup}
                setDomainGroup={setDomainGroup}
                domainNames={domainNames}
                onCellValueChanged={handleCellValueChanged}
                onClickAddDomainItem={handleClickAddDomainItem}
                onClickRemoveDomainItem={handleClickRemoveDomainItem}
              />
            </React.Fragment>
          )}
          </FormLayoutContent>
        </FormLayout>
      </div>
    )
}

export default FqdnCreate;
